import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ProductsProvider } from './context/products_context';
import { FilterProvider } from './context/filter_context';
import { CartProvider } from './context/cart_context';
import { UserProvider } from './context/user_context';
import { OrderProvider } from './context/order_context';
import { UserDetailsProvider } from './context/user_details_context';
import theme from './config/ThemeConfig';
import { ChakraProvider } from '@chakra-ui/react';

ReactDOM.render(
  <UserProvider>
    <UserDetailsProvider>
    <ProductsProvider>
      <FilterProvider>
        <CartProvider>
          <OrderProvider>
            <ChakraProvider theme={theme}>
              <App />
            </ChakraProvider>
          </OrderProvider>
        </CartProvider>
      </FilterProvider>
    </ProductsProvider>
    </UserDetailsProvider>
  </UserProvider>,
  document.getElementById('root')
);
